import React from 'react'

export default function StockInInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .table-stock-out-container {
          display: flex;
          border: solid 1px lightgrey;
          flex-direction: column; /* Necessary for Firefox browser */
          justify-content: stretch;
          font-size: 0.65em;
        }
        .title-header {
          display: flex;
        }
        .title-header:hover {
          cursor: pointer;
        }
        .title-header div {
          flex: 2;
        }
        .title-header span {
          text-align: right;
        }
        
        .so-checkbox {
          margin-top: 11px;
          margin-left: 12px;
        }

        .status {
          text-align: center;
          border-radius: 3px;
          padding: 3px 5px;
          color: white;
        }
        .status.unposted { background-color: red; }
        .status.posted { background-color: blue; }
        .status.on.process { background-color: green; }
        .status.inactive { background-color: lightgrey; }
      `}
      </style>
    </React.Fragment>
  )
}
